var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('product-search',{attrs:{"linkId":_vm.linkId}})}
var staticRenderFns = []

export { render, staticRenderFns }